export const barberProfiles = [
  {
    name: "Kecskeméti Ferenc",
    id: "kecskemeti-ferenc",
    introduction:
      "Kecskeméti Ferenc, KECSO vagyok! Az ARTIST Barber shop, Brand megálmodója, cég tulajdonosa. Célom egy olyan hely, szalon, gondolkodásmód, életfelfogás átadása ami arra ösztönöz mindenkit, hogy csinálja azt amiben igazán hisz és tudja, ha beleteszi magát, NINCS LEHETETLEN !🤩",
    introductionParts: {
      intFirst:
        "Kecskeméti Ferenc, KECSO vagyok! Az ARTIST Barber shop, Brand megálmodója, cég tulajdonosa.",
      intSecond:
        "Célom egy olyan hely, szalon, gondolkodásmód, életfelfogás átadása ami arra ösztönöz mindenkit, hogy csinálja azt amiben igazán hisz és tudja, ha beleteszi magát, NINCS LEHETETLEN !🤩",
    },
    suggestion: {
      sugFirst:
        "Hello hello! Ha szeretsz kitűnni a tömegből, egyedi stílusod van, amivel nem mindenki tud azonosulni akkor én vagyok a te embered! Szeretem a kihívásokat! Ahogy a magánéletemben is úgy a munkámban is a legextrémebb, leglazább VIBE-ot képviselem. Hogyan lehetne még ennél is jobb? Segítek!",
      sugSecond: "Időpont foglalás: Kecskeméti Ferenc 🔥!",
    },
    experience: "5 éve vagyok benne a szakmában",
    profilePicture: "kecso_stroke.jpg",
    reservationUrl:
      "https://www.fresha.com/hu/a/artist-barber-shop-mosonmagyarovar-magyar-utca-4-kr8qumem/booking?employeeId=2312372",
    location: "Mosonmagyaróvár, Csorna",
    references: [
      {
        src: "/barber_portfolio/kecso/portfolio-1.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/kecso/portfolio-2.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/kecso/portfolio-3.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/kecso/portfolio-4.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/kecso/portfolio-5.jpg",
        width: 591,
        height: 676,
      },
    ],
  },
  {
    name: "Gyarmati Denisz",
    id: "gyarmati-denisz",
    introduction:
      "Sziasztok Gyarmati Denisz vagyok! Hobbiként kezdtem el ezt csinálni és a szenvedélyemmé vált, nagyon örülök neki hogy, a hobbim a munkám lett. Hosszú utat jártam be azért a tudásért amit most birtokolok.",
    introductionParts: {
      intFirst: "Sziasztok Gyarmati Denisz vagyok!",
      intSecond:
        "Hobbiként kezdtem el ezt csinálni és a szenvedélyemmé vált, nagyon örülök neki hogy, a hobbim a munkám lett. Hosszú utat jártam be azért a tudásért amit most birtokolok.",
    },
    suggestion: {
      sugFirst:
        "Én vagyok a legjobb választás számodra, lehető legjobb tudásomat fogom nyújtani, akár egy képpel vagy egy elképzeléssel érkezel meg hozzám.",
      sugSecond:
        "A te stílusodhoz, munkádhoz és a mindennapjaidhoz fogom szabni a hajadat ami garantált jókedvet fog okozni neked!!",
    },
    experience: "3 éve kezdtem el vele komolyabban foglalkozni",
    profilePicture: "denisz_stroke.jpg",
    reservationUrl:
      "https://www.fresha.com/hu/a/kecso-hair-barber-shop-csorna-soproni-ut-63-esv2xp2x/booking?employeeId=1541192",
    location: "Csorna",
    references: [
      {
        src: "/barber_portfolio/denisz/portfolio-1.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/denisz/portfolio-2.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/denisz/portfolio-3.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/denisz/portfolio-4.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/denisz/portfolio-5.jpg",
        width: 591,
        height: 676,
      },
    ],
  },
  {
    name: "Iváncsis Kristóf",
    id: "ivancsis-kristof",
    introduction:
      "Ivancsics Kristóf vagyok, 23 éves. Én a hajvágásra művészetként tekintek. Szeretek egyedit, kreatívat valami újat alkotni. Egyaránt szeretem a modern, kreatív és a klasszikus hajvágási irányzatokat.",
    introductionParts: {
      intFirst: "Ivancsics Kristóf vagyok, 23 éves.",
      intSecond:
        "Én a hajvágásra művészetként tekintek. Szeretek egyedit, kreatívat valami újat alkotni. Egyaránt szeretem a modern, kreatív és a klasszikus hajvágási irányzatokat.",
    },
    suggestion: {
      sugFirst:
        "Vendégeim  részére mindig a legjobb tudásom nyújtom. Ugy gondolom a hajvágás vagy szakálligazítás nem csak sima munkáról szól.",
      sugSecond:
        "Fontosnak tartom vendégeim kiismerését hogy személyre szabhassam a szolgáltatásom. Törekszem ügyfeleimből mindig kihozni a maximumot.",
    },
    experience: "Több mint 1 éve foglalkozok hajvágással",
    profilePicture: "ivancsis_stroke.jpg",
    reservationUrl:
      "https://www.fresha.com/hu/a/kecso-hair-barber-shop-csorna-soproni-ut-63-esv2xp2x/booking?employeeId=2820036",
    location: "Csorna",
    references: [
      {
        src: "/barber_portfolio/ivancsis/portfolio-1.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/ivancsis/portfolio-2.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/ivancsis/portfolio-3.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/ivancsis/portfolio-4.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/ivancsis/portfolio-5.jpg",
        width: 591,
        height: 676,
      },
    ],
  },
  {
    name: "Tar Bálint",
    id: "tar-balint",
    introduction:
      "Sziasztok Bálintnak hívnak, 17 éves vagyok, én vagyok a legfiatalabb a csapatba. Fél év dolgozok a kecso hairbe, szeretek beszélgetni a vendégeimmel, mert egy jó hangulatot szeretnék okozni neked/nektek és kitudtok kapcsolódni nálam.",
    introductionParts: {
      intFirst:
        "Sziasztok Bálintnak hívnak, 17 éves vagyok, én vagyok a legfiatalabb a csapatba.",
      intSecond:
        "Fél év dolgozok a kecso hairbe, szeretek beszélgetni a vendégeimmel, mert egy jó hangulatot szeretnék okozni neked/nektek és kitudtok kapcsolódni nálam.",
    },
    suggestion: {
      sugFirst:
        "Ha különleges hajakat szeretnél nyugodtan választhatsz engem, mert kreativitásaim nem szabnak határokat és mindent képes vagyok véghez vinni",
      sugSecond:
        "Elég fiatalon kezdtem a szakmát, és próbálok minél többet fejlődni az idők során és elsajátítani a magam stílusát",
    },

    experience: "Lassan 2 éve foglalkozok hajnyírással",
    profilePicture: "tar_stroke.jpg",
    reservationUrl:
      "https://www.fresha.com/hu/a/kecso-hair-barber-shop-csorna-soproni-ut-63-esv2xp2x/booking?employeeId=2684470",
    location: "Csorna",
    references: [
      {
        src: "/barber_portfolio/tar/portfolio-1.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/tar/portfolio-2.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/tar/portfolio-3.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/tar/portfolio-4.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/tar/portfolio-5.jpg",
        width: 591,
        height: 676,
      },
    ],
  },
  {
    name: "Demeter Adorján",
    id: "demeter-adorjan",
    introduction:
      "Sziasztok! Demeter Adorján vagyok, közvetlen kedves és jó fej, erősségem a fiatalos kreatív hajtetoválások elkészítése és bármilyen hajstílusban is otthonosan érzem magam!💥",
    introductionParts: {
      intFirst: "Sziasztok! Demeter Adorján vagyok, közvetlen kedves és jó fej",
      intSecond:
        "Erősségem a fiatalos kreatív hajtetoválások elkészítése és bármilyen hajstílusban is otthonosan érzem magam!💥",
    },
    suggestion: {
      sugFirst: "Hogy miért érdemes hozzám járni🔥?",
      sugSecond:
        "Úgy gondolom hogy nagyon fontos hogy a hozzád illő legjobb haj stílust kombinálva a kreativitásommal alkossam meg neked ezt, valamint tiszta és precíz végeredményt kapj, és elégedett legyél!🙌",
    },
    experience: "2 éve foglalkozok borbélykodással",
    profilePicture: "adorjan_stroke.jpg",
    reservationUrl:
      "https://www.fresha.com/hu/a/artist-barber-shop-mosonmagyarovar-magyar-utca-4-kr8qumem/booking?employeeId=2312242",
    location: "Mosonmagyaróvár",
    references: [
      {
        src: "/barber_portfolio/demeter/portfolio-1.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/demeter/portfolio-2.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/demeter/portfolio-3.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/demeter/portfolio-4.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/demeter/portfolio-5.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/demeter/portfolio-6.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/demeter/portfolio-7.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/demeter/portfolio-8.jpg",
        width: 591,
        height: 676,
      },
    ],
  },
  {
    name: "Varga Kristóf",
    id: "varga-kristof",
    introduction:
      "Varga Kristóf vagyok, 25 éves, 4 éve foglalkozom hajvágással, ezidő alatt, a sok munka mellett, rengeteg energiát/időt fordítottam a fejlődésemre, továbbképzések formájában, ahol a legjobbaktól tanulhattam el ezen szakma fortélyait es az ezzel járó szolgáltatás részeit.",
    introductionParts: {
      intFirst: "Varga Kristóf vagyok, 25 éves",
      intSecond:
        "4 éve foglalkozom hajvágással, ezidő alatt, a sok munka mellett, rengeteg energiát/időt fordítottam a fejlődésemre, továbbképzések formájában, ahol a legjobbaktól tanulhattam el ezen szakma fortélyait es az ezzel járó szolgáltatás részeit.",
    },
    suggestion: {
      sugFirst: "Beszélgetnél egy jót,vagy csak kikapcsolódnál? ",
      sugSecond:
        "Nálam mindegyikre van lehetőség a jó hajvágás mellett! (Szakállvágásnál inkább a kikapcsolódást válaszd!!😄)",
    },
    experience: "4 éve foglalkozom hajvágással",
    profilePicture: "varga_stroke.jpg",
    reservationUrl:
      "https://www.fresha.com/hu/a/artist-barber-shop-mosonmagyarovar-magyar-utca-4-kr8qumem/booking?employeeId=2312372",
    location: "Győr",
    references: [
      {
        src: "/barber_portfolio/varga/portfolio-1.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/varga/portfolio-2.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/varga/portfolio-3.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/varga/portfolio-4.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/varga/portfolio-5.jpg",
        width: 591,
        height: 676,
      },
    ],
  },
  {
    name: "Jónás Manó",
    id: "jonas-mano",
    introduction:
      "Jónás Manó vagyok, 20 éves és minden hajjal kapcsolatos dolog már egészen gyerekkorom óta érdekelt. Eleinte csak nézegettem, hogy más borbélyok mégis miként vágják a hajam, mit miért csinálhatnak. Ahogy felnőttem pedig tüzetesebben elkezdtem foglalkozni a szakmával kapcsolatos dolgokkal.",
    introductionParts: {
      intFirst:
        "Jónás Manó vagyok, 20 éves és minden hajjal kapcsolatos dolog már egészen gyerekkorom óta érdekelt.",
      intSecond:
        "Eleinte csak nézegettem, hogy más borbélyok mégis miként vágják a hajam, mit miért csinálhatnak. Ahogy felnőttem pedig tüzetesebben elkezdtem foglalkozni a szakmával kapcsolatos dolgokkal.",
    },
    suggestion: {
      sugFirst:
        "Hogyha nem csak egy bomba haj miatt jössz, ami minden esetben biztosítva van, egyénileg rád vágva, személytől függően, mivel minden ember és minden haj, más és más dolgokat rejteget magában, de ha szeretnél egy jót beszélgetni hajvágás közben, nálam azt is lehet nyugodtan, minden témában nyitott vagyok!",
      sugSecond:
        "2023 Szeptembere óta megállás nélkül vágom a hajakat és fejlődöm nap, mint nap. A határ pedig nem a csillagos ég, annál valami sokkal több!",
    },
    experience:
      "2022 Novemberében vágtam az első hajamat, azóta sok oktatáson vettem részt és a legjobbaktól tanultam.",
    profilePicture: "mano_stroke.jpg",
    reservationUrl:
      "https://www.fresha.com/hu/a/artist-barber-shop-mosonmagyarovar-magyar-utca-4-kr8qumem/booking?employeeId=2619797",
    location: "Mosonmagyaróvár, Csorna",
    references: [
      {
        src: "/barber_portfolio/mano/portfolio-1.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/mano/portfolio-2.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/mano/portfolio-3.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/mano/portfolio-4.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/mano/portfolio-5.jpg",
        width: 591,
        height: 676,
      },
    ],
  },
  {
    name: "Tóth Máté",
    id: "toth-mate",
    introduction:
      "Sziasztok! Máté vagyok, 24 éves. Számomra a munkám egyben a hobbim is, ezáltal önmagam fejlesztése, újabb technikák, stílusok, trendek elsajátítása örömmel tölt el. Kettő szó, amivel jellemezném magam: maximalista, lojális.",
    introductionParts: {
      intFirst: "Sziasztok! Máté vagyok, 24 éves.",
      intSecond:
        "Számomra a munkám egyben a hobbim is, ezáltal önmagam fejlesztése, újabb technikák, stílusok, trendek elsajátítása örömmel tölt el. Kettő szó, amivel jellemezném magam: maximalista, lojális.",
    },
    suggestion: {
      sugFirst:
        "Szándékom, hogy minden vendégem számára a szakmai tudásom legjavát nyújtsam s a szolgáltatásom végén önbizalommal tele, elégedetten lépjenek ki a szalonból.",
      sugSecond:
        "Úgy gondolom, hogy nem a szakmában eltöltött idő, sokkal inkább az önmagunkba való fektetés az ami meghatároz minket.",
    },
    experience: "Közel 3 éve dolgozom borbélyként",
    profilePicture: "toth_stroke.jpg",
    reservationUrl:
      "https://www.fresha.com/hu/a/artist-barber-shop-mosonmagyarovar-magyar-utca-4-kr8qumem/booking?employeeId=2312372",
    location: "Győr",
    references: [
      {
        src: "/barber_portfolio/toth/portfolio-1.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/toth/portfolio-2.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/toth/portfolio-3.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/toth/portfolio-4.jpg",
        width: 591,
        height: 676,
      },
      {
        src: "/barber_portfolio/toth/portfolio-5.jpg",
        width: 591,
        height: 676,
      },
    ],
  },
];
